var cov_19kxf5fh2h = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/index.ts",
      hash = "b7f5f276e69452e57cd333bda703379b17683867",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 38
        },
        end: {
          line: 7,
          column: 96
        }
      },
      "1": {
        start: {
          line: 8,
          column: 23
        },
        end: {
          line: 11,
          column: 11
        }
      },
      "2": {
        start: {
          line: 13,
          column: 0
        },
        end: {
          line: 13,
          column: 47
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Transfer from './Transfer';
import inputable from '../Form/inputable';
import { compose } from '../utils/func';
import Datum from '../Datum';
var bindProps = (cov_19kxf5fh2h.s[0]++, ['disabled', 'limit', 'format', 'prediction', 'separator']);
var exportTransfer = (cov_19kxf5fh2h.s[1]++, compose(inputable, Datum.hoc({
  bindProps: bindProps
}))(Transfer));
cov_19kxf5fh2h.s[2]++;
exportTransfer.displayName = 'ShineoutTransfer';
export default exportTransfer;